export const mockActivity = {
  data: {
    content: [
      {
        id: '3fa85f64-5717-4562-b3fc-2c963f66afa6',
        name: 'Alex Popescu',
        description:
          'Changed Voucher ID 124842 Label from Endava 1 to Endava 2',
        date: 1696410000000,
        email: 'alex.popescu@gmail.com',
      },
      {
        id: '3fa85f64-5717-4562-dser-2c963f66afa6',
        name: 'Ana Cojocaru',
        description: 'Changed Ticket Category VIP to General Access',
        date: 1696410000000,
        email: 'ana.cojocaru@gmail.com',
      },
      {
        id: '3fa85f64-5717-4562-lovd-2c963f66afa6',
        name: 'Cristian Cojocaru',
        description: 'Change Stage name from Main Stage to Second Stage',
        date: 1696410000000,
        email: 'cristian007@gmail.com',
      },
    ],
    totalElements: 3,
    totalPages: 1,
    size: 10,
    pageNumber: 1,
    empty: true,
  },
}
